<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'App',
  }
</script>

<style lang="scss">
  @import "../scss/variables";

  body {
    font-family: 'DinRegular';
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'DinCondMedium';
  }

  ul, ol {
    list-style: none;
    padding-left: 0;
  }

  a {
    cursor: pointer;
  }

  .break-word {
    word-wrap: break-word;
  }

  .content .content-toolbar {
    text-align: right;
    margin-bottom: 2rem;
  }

  .modal-mask {
    .modal-wrapper {
      .modal-container {
        .modal-body {
          overflow: auto;
        }
        .modal-header {
          background-color: white;
        }
      }
    }
  }

  .btn {
    &.btn-primary {
      background-color: $suez-green;
      color: rgba($suez-blue, .8);
      border-color: $suez-green;
    }
    &.btn-default {
      background-color: darken($suez-grey, 10%);
      color: darken($suez-grey-dark, 80%);
      border-color: $suez-grey;
    }
  }

  .title-item {
    font-size: 0.8em;
    color: grey;
    display: block;
    &.topSpace {
      margin-top: 8px;
    }
  }

  .text-item {
    font-weight: bold;
    word-wrap: break-word;
    &--sm {
      font-weight: initial;
    }
    &--password {
      margin-bottom: -8px;
    }
    .no-data {
      color:rgba(black, .5);
    }
  }

  .change-password {
    display: block;
    color: rgba($suez-blue, .8);
    cursor: pointer;
    &:hover {
      color: rgba($suez-blue, .8);
      text-decoration: underline;
    }
  }

  .right-separator {
    border-right: 1px solid $suez-grey;
  }

  .left-separator {
    border-left: 1px solid $suez-grey;
  }

</style>



// WEBPACK FOOTER //
// App.vue?278f345d